export const handleChangeTrendToggle = (state, payload) => {
    return {
        ...state,
        trendToggle: !state.trendToggle

    }
}